<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template
          slot-scope="scope"
          slot="menuLeft"
        >
          <el-button
            type="primary"
            size="small"
            plain
            @click.stop="downloadExcel(scope.row)"
          >下载Excel</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="menu"
        >
          <el-button
            type="primary"
            size="small"
            plain
            @click.stop="openPay(scope.row)"
            v-if="scope.row.status=='WAIT_PAY'"
          >立即付款</el-button>
          <el-button
            type="success"
            icon="el-icon-view"
            size="small"
            plain
            @click.stop="opendistribution(scope.row)"
          >查看配送单</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="status"
        >
          <el-tag
            v-for="obj of distributionSheetStatus"
            :key="obj.value"
            v-if="obj.value == scope.row.status"
          >{{obj.label}}</el-tag>
          <el-tag
            v-for="obj1 of shopType"
            :key="obj1.value"
            v-if="obj1.value == scope.row.status"
          >{{obj.label}}</el-tag>
        </template>
        <!-- <template
          slot-scope="scope"
          slot="status"
        >
          <el-tag
            v-for="obj of shopType"
            :key="obj.value"
            v-if="obj.value == scope.row.status"
          >{{obj.label}}</el-tag>
        </template> -->
      </avue-crud>
      <template>
        <el-dialog
          :visible.sync="rechargeDialog"
          title="充值"
          center
          width="1000px"
        >
          <div
            class="remittance"
            style="font-size: 14px;display: flex;flex-flow: column nowrap; align-items: flex-start;margin-left:205px"
          >
            <div class="recharge">
              <span style="width:130px;text-align:left;">请输入充值金额:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <el-input
                type="number"
                placeholder="请输入充值金额"
                v-model="rechargeMoney"
                style="width:215px"
              ></el-input>
            </div>
            <div style="display: flex;justify-content:flex-start;">
              <span style="width:130px;text-align:left;">支付方式:</span>
              <div>
                <el-radio
                  v-model="payRadio"
                  label="OFFLINE_REMIT"
                  @change="rechargeWayOFFLINE_REMIT"
                >线下汇款</el-radio>
                <el-radio
                  v-model="payRadio"
                  label="WX_PAY"
                  @change="rechargeWayWX_PAY"
                >微信支付</el-radio>
              </div>
            </div>
            <div
              class="recharge"
              v-if="this.payRadio == 'OFFLINE_REMIT'"
            >
              <span style="width:130px;text-align:left;">汇款账户名称:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <el-input
                type="text"
                placeholder="请输入汇款账户名称"
                v-model="remittanceAccountName"
                style="width:215px"
              ></el-input>
              <i style="font-style:normal;display: inline;font-size: 12px;color:red">&nbsp;&nbsp;个人储蓄卡请填写持卡人姓名，对公账户请填写账户名称</i>
            </div>
            <div
              class="recharge"
              v-if="this.payRadio == 'OFFLINE_REMIT'"
            >
              <span style="width:130px;text-align:left;">汇款账户:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <el-input
                type="text"
                placeholder="请输入汇款账户"
                v-model="remittanceAccount"
                style="width:215px"
              ></el-input>
            </div>
            <div
              class="recharge"
              v-if="this.payRadio == 'OFFLINE_REMIT'"
              style="display: flex;justify-content:flex-start;"
            >
              <span style="width:130px;text-align:left;">汇款银行:</span>
              <div>
                <el-select
                  placeholder="请输入汇款银行"
                  v-model="currBank"
                  style="width:215px"
                >
                  <el-option
                    v-for="item in remittanceBank"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div
              class="recharge"
              v-if="this.payRadio == 'OFFLINE_REMIT'"
              style=" margin-bottom:40px "
            >
              <span style="width:130px;text-align:left; ">凭证:</span>
              <el-upload
                :multiple="true"
                action="#"
                accept="image/jpeg, image/gif, image/png, image/bmp"
                :file-list="fileList1"
                :http-request="fnUploadremittanceImgs"
                :show-file-list="false"
              >
                <div
                  v-if="'' != remittanceImgs"
                  class="el-upload el-upload--picture-img"
                >
                  <img
                    v-for="remittanceImg of remittanceImgs"
                    :key="remittanceImg.value"
                    :src="remittanceImg"
                    style="width: 200px;"
                  />
                </div>
                <div
                  v-else
                  class="el-upload el-upload--car-two"
                >
                  <i class="el-icon-plus"></i>
                </div>
                <div class="el-upload__tip">请上传汇款回单凭证，只能上传jpg/png图片，且不超过500kb</div>
              </el-upload>
            </div>
            <div
              class="recharge"
              v-if="this.payRadio == 'OFFLINE_REMIT'"
            >
              <span style="width:130px;text-align:left;">账户名称:</span>
              成都聚家科技有限公司
            </div>
            <div
              class="recharge"
              v-if="this.payRadio == 'OFFLINE_REMIT'"
            >
              <span style="width:130px;text-align:left;">账户号码:</span>
              4402209109100103208
            </div>
            <div
              class="recharge"
              v-if="this.payRadio == 'OFFLINE_REMIT'"
            >
              <span style="width:130px;text-align:left;">开户银行:</span>
              中国工商银行股份有限公司成都天顺路支行
            </div>
            <div
              class="recharge"
              v-if="this.payRadio == 'OFFLINE_REMIT'"
            >
              <span style="width:130px;text-align:left;">汇款提示:</span>
              请避免北京时间18：00-00：00进行汇款，否则受银行出账时间影响，可能出现延迟一天到账情况。
            </div>
          </div>
          <div class="remittanceButton">
            <el-button
              round
              size="mini"
              @click="balancePayment"
            >&nbsp;&nbsp;&nbsp;立即充值&nbsp;&nbsp;&nbsp;</el-button>
            <el-button
              round
              type="danger"
              size="mini"
              @click="rechargeDialog = false"
            >&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;</el-button>
          </div>
        </el-dialog>
      </template>

      <template>
        <el-dialog
          title="二维码支付"
          :visible.sync="QRCodeDialog"
          align="center"
        >
          <vue-qr
            :text="config.value"
            :size="200"
          ></vue-qr>
          <el-row>二维码只会展示2分钟，请及时支付</el-row>
          <el-button @click="closeQRCodeDialog">关闭</el-button>
        </el-dialog>
      </template>

      <el-dialog
        title="选择付款方式"
        center
        :visible.sync="dialogBalancePay"
        width="50%"
      >
        <div style="display: flex;justify-content: space-around;">
          <el-radio
            v-if="!noMoney"
            v-model="balancePayRadio"
            label="YE"
          >账户余额({{getBalance+'元'}})</el-radio>
          <el-radio
            v-if="noMoney"
            v-model="balancePayRadio"
            label="YE"
          >
            账户余额(
            <span style="color:red">
              余额不足
              <a
                href="#"
                style="color:#409EFF;margin-left:3px;text-decoration: underline;"
                @click="toPayMoney"
              >去充值</a>
            </span>)
          </el-radio>
          <el-radio
            v-model="balancePayRadio"
            label="WX"
          >微信支付</el-radio>
        </div>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="dialogBalancePay = false">取 消</el-button>
          <el-button
            type="primary"
            @click="listPay"
          >确认支付</el-button>
        </span>
      </el-dialog>

    </basic-container>
    <el-dialog
      :visible.sync="distributionDialog"
      :before-close="beforeClose"
      done
      center
      width="1000px"
      v-if="isOpen"
    >
      <div class="stockwrap">
        <!--startprint-->
        <div
          v-bind="distributionData"
          class="stockMain"
          id="printBox"
        >
          <h1
            class="stockMain title"
            id="printTitle"
          >配送单详情</h1>
          <div
            v-if="isPrint"
            id="printTime"
          >
            <div>{{"打印时间："+handleFormatterDateToUTC(new Date().getTime()) }}</div>
            <div>{{this.companyName}}</div>
          </div>
          <div
            class="stockMain content"
            id="content"
          >
            <table
              border
              style="width:900px"
            >
              <tr>
                <th style="width:300px">配送单编号:</th>
                <th style="width:300px;">{{distributionData.distributionNum}}</th>
                <th style="width:300px">下单人:</th>
                <th style="width:300px">{{distributionData.bookingClerk}}</th>
              </tr>
              <tr>
                <th style="width:300px">下单人电话:</th>
                <th style="width:300px">{{distributionData.bookingTel}}</th>
                <th style="width:300px">联系人:</th>
                <th style="width:300px">{{distributionData.contactsName}}</th>
              </tr>
              <tr>
                <th style="width:300px">联系人电话:</th>
                <th style="width:300px">{{distributionData.contactsMobile}}</th>
                <th style="width:300px">联系地址:</th>
                <th style="width:300px">{{distributionData.address}}</th>
              </tr>
              <tr>
                <th style="width:300px">配送费用:</th>
                <th style="width:300px">{{distributionData.distributionCost}}</th>
                <th style="width:300px">创建时间:</th>
                <th style="width:300px">{{handleFormatterDateToUTC(distributionData.createTime)}}</th>
              </tr>

              <tr>
                <th style="width:300px">配送单状态:</th>
                <th
                  v-for="obj of distributionSheetStatus"
                  :key="obj.value"
                  v-if="obj.value == distributionData.status"
                >{{obj.label}}</th>
                <th style="width:300px">出货类型:</th>
                <th
                  v-for="obj of shopType"
                  :key="obj.value"
                  v-if="obj.value == distributionData.type"
                >{{obj.label}}</th>
                <!-- <th style="width:300px">{{ distributionData.status == 'WAIT_AUDIT' ? '待审核' : (distributionData.status == 'RETURNED' ? '已退回' : '已完成')}}</th> -->
                <!-- <th style="width:300px">收货时间:</th>
                <th style="width:300px">{{distributionData.receiveTime?handleFormatterDateToUTC(distributionData.receiveTime):distributionData.receiveTime}}</th> -->
              </tr>
              <tr>
                <th style="width:300px">收货时间:</th>
                <th style="width:300px">{{distributionData.receiveTime?handleFormatterDateToUTC(distributionData.receiveTime):distributionData.receiveTime}}</th>
              </tr>
            </table>
            <avue-crud
              :option="table3Option"
              :data="table3Data"
              :table-loading="tableLoading"
              border
              ref="crud1"
              style="margin:0;margin-top:15px"
            ></avue-crud>
          </div>
          <div
            class="stockMain btn"
            id="noprint"
          >
            <!-- <el-button @click="doPdf">下载PDF</el-button> -->
            <el-button @click="doPrint">导出为PDF文件</el-button>
          </div>
        </div>
        <!--endprint-->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { distributionSheetOption } from "@/const/salesCloud/distributionSheetOption";
import { distributionFormOption } from "@/const/salesCloud/distributionFormOption";
import { distributionEngineerFormOption } from "@/const/salesCloud/distributionEngineerFormOption";
import {
  viDistributionSheetList,
  payDistributionFee,
  payWXDistributionFee,
  viDistributionSheetFindDetail,
  viDistributionSheetListDownloadExcel,
} from "@/api/salesCloud/distributionSheet";
import { wxNativePayQuery } from "@/api/salesCloud/depositRecharge";

import { getCompany } from "@/util/auth";
import { formatterDateToUTC, parseStatus } from "@/util/util";
// import {findByLabel} from "@/util/util"
import { DIC } from "@/const/dic";
import VueQr from "vue-qr";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import oss from "ali-oss";
import md5 from "js-md5";
import { findBalance, addBalance } from "@/api/salesCloud/accountBalance";
export default {
  name: "distributionSheet",
  components: {
    VueQr,
  },
  data() {
    return {
      tableOption: distributionSheetOption, //表格设置属性
      tableData: [], //表格的数据
      table1Data: [],
      table1Option: distributionFormOption, //表格设置属性
      table2Data: [],
      table2Option: distributionEngineerFormOption, //表格设置属性
      table3Option: {}, //表格的数据
      table3Data:[],
      tablePage: 1,
      tableLoading: false,
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10, //每页显示多少条
      },
      grade: {
        box: false,
        check: [],
      },
      isOpen: false,
      isPrint: false,
      distributionData: {},
      companyName: "",
      downloadData: {},
      //余额支付
      balancePayRadio: "YE",
      serviceCategorys: [],
      serviceCategory: {},
      joinsWorkServiceItems: [],
      workOrderStatus: DIC.WORK_ORDER_STATUS,
      QRCodeDialog: false,
      config: {},
      noMoney: true,
      getBalance: 0,
      distributionDialog: false,
      evaluateDialog: false,
      dialogBalancePay: false,
      rechargeDialog: false,
      rechargeMoney: "",
      payRadio: "OFFLINE_REMIT",
      remittanceAccountName: "",
      remittanceAccount: "",
      currBank: "",
      remittanceBank: DIC.BANK_LIST,
      fileList1: [],
      remittanceImgs: [],

      distributionSheetStatus: DIC.DISTRIBUTION_SHEET_STATUS,
      shopType: DIC.SHOP_TYPE,
    };
  },
  created() {
    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"]),
  },
  props: [],
  methods: {
    //转换为标准时间
    handleFormatterDateToUTC(data) {
      return formatterDateToUTC(data);
    },
    beforeClose(done) {
      this.rowId = "";
      console.log(this.rowId);
      done();
    },
    opendistribution(row) {
      console.log(row);
      console.log(row,2222);
      this.distributionDialog = true;
      this.isOpen = true;
      this.rowId = row.id;
      // this.type=row.type;
      if(row.type == "NORMAL"){
      viDistributionSheetFindDetail(this.rowId).then((res) => {
        let data = JSON.parse(res.data);
        console.log(data,11111);
        this.distributionData = data;
        this.isOpen = true;
        this.table1Data = data.goods;
        this.table3Option=this.table1Option;
        this.table3Data=this.table1Data;
        // this.table1Data[0].brand="";
        // this.table1Data[0].skuValue="";
        console.log(this.table1Data[0].brand,333);
        this.tableLoading = false;
      });
      }else{
        viDistributionSheetFindDetail(this.rowId).then((res) => {
        let data = JSON.parse(res.data);
        console.log(data,11111);
        this.distributionData = data;
        this.isOpen = true;
        this.table2Data = data.goods;
        console.log(this.table2Data,22222);
        this.table3Option=this.table2Option;
        this.table3Data = this.table2Data;
        // this.table1Data[0].brand="";
        // this.table1Data[0].skuValue="";
        // console.log(this.table1Data[0].brand,333);
        this.tableLoading = false;
      });
      }
      // this.$router.push({
      //   name: "采购退货单",
      //   params: { id: row.id }
      // });
    },
    openPay(row) {
      console.log(row);
      this.payRow = row;
      findBalance().then((res) => {
        let data = JSON.parse(res.data);
        this.getBalance = data.rows[0].balance;
        let wxPay = row.distributionCost;
        // let wxPay = 1111111;
        console.log(wxPay, this.getBalance);
        this.noMoney = wxPay > this.getBalance;
        this.dialogBalancePay = true;
      });
    },
    getBalanceMoney() {
      findBalance().then((res) => {
        let data = JSON.parse(res.data);
        this.getBalance = data.rows[0].balance;
        console.log(this.getBalance);
      });
    },
    listPay() {
      if (this.balancePayRadio == "WX") {
        this.immediatePayment(this.payRow.id);
      } else {
        payWXDistributionFee(this.payRow.id).then((res) => {
          console.log(res);
          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: "支付成功",
              type: "success",
            });
            this.handleList();
            setTimeout(() => {
              this.handleList();
            }, 1000);
            this.dialogBalancePay = false;
          } else {
            this.$message({
              showClose: true,
              message: "余额不足",
              type: "error",
            });
            this.handleList();
            this.dialogBalancePay = false;
          }
          this.handleList();
        });
      }
    },
    destroyThisPay() {
      this.QRCodeDialog = false;
      this.rechargeDialog = false;
      this.payMoneyDialog = false;
      this.dialogBalancePay = false;
    },
    clean() {
      this.describeImgs = [];
      this.remittanceImgs = [];
      this.rechargeMoney = "";
      this.paymentTask = {};
      this.remittanceAccountName = "";
      this.remittanceAccount = "";
      this.currBank = "";
    },
    balancePayment() {
      let params = {};
      params.money = this.rechargeMoney;
      params.rechargeType = "BALANCE";
      params.payType = this.payRadio;
      params.openingUser = this.remittanceAccountName;
      params.bankNumber = this.remittanceAccount;
      params.bankName = this.currBank;
      params.url = this.remittanceImgs + "";
      if (params.payType == "OFFLINE_REMIT") {
        if (
          params.money &&
          params.openingUser &&
          params.bankNumber &&
          params.bankName &&
          params.url
        ) {
          addBalance(params).then((res) => {
            if (res.code == "200") {
              this.$message({
                showClose: true,
                message:
                  "非常感谢您对慧家平台的信任，请耐心等待平台财务人员核实。",
                type: "success",
              });
              this.rechargeDialog = false;
              this.payMoneyDialog = false;
              this.dialogBalancePay = false;
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error",
              });
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: "请完善输入信息",
            type: "error",
          });
        }
      } else {
        addBalance(params).then((response) => {
          this.tableLoading = false;
          if (response.code == "200") {
            let data = response.data;
            let count = 0;
            wxNativePayQuery(data.outTradeNo).then((res) => {
              if (res.code == "200") {
                if (res.data == "SUCCESS") {
                  let _this = this;
                  setTimeout(function () {
                    _this.QRCodeDialog = false;
                    _this.$message({
                      showClose: true,
                      message: "充值成功",
                      type: "success",
                    });
                    _this.handleList();
                    _this.payMoneyDialog = false;
                    _this.rechargeDialog = false;
                    _this.dialogBalancePay = false;
                  }, 1000);
                } else {
                  count++;
                  if (count < 3) {
                    wxNativePayQuery(data.outTradeNo).then((res) => {
                      if (res.code == "200") {
                        if (res.data == "SUCCESS") {
                          let _this = this;
                          setTimeout(function () {
                            _this.QRCodeDialog = false;
                            _this.$message({
                              showClose: true,
                              message: "充值成功",
                              type: "success",
                            });
                            _this.handleList();
                            _this.payMoneyDialog = false;
                            _this.rechargeDialog = false;
                            _this.dialogBalancePay = false;
                          }, 1000);
                        } else {
                          this.QRCodeDialog = false;
                          this.rechargeDialog = false;
                          this.dialogBalancePay = false;
                          this.$message({
                            showClose: true,
                            message: "支付超时",
                            type: "error",
                          });
                        }
                      } else {
                        this.QRCodeDialog = false;
                        this.rechargeDialog = false;
                        this.dialogBalancePay = false;
                        this.$message({
                          showClose: true,
                          message: "支付超时",
                          type: "error",
                        });
                      }
                    });
                  }
                }
                //this.handleList();
              } else {
                this.QRCodeDialog = false;
                this.$message({
                  showClose: true,
                  message: "支付失败",
                  type: "error",
                });
                this.handleList();
              }
            });
            let start = new Date().getTime();
            while (true) if (new Date().getTime() - start > 1) break;
            this.config.value = "";
            this.config.value = data.codeUrl;
            this.QRCodeDialog = true;
          } else {
            this.$message({
              showClose: true,
              message: "支付失败",
              type: "error",
            });
            //???下面的感觉没用
            // this.$refs.crud.rowAdd();
            return;
          }
          // let data = JSON.parse(res.data);
        });
      }
    },
    rechargeWayBALANCE() {
      this.paymentTask.rechargeWay = "BALANCE";
    },
    rechargeWayWX_PAY() {
      this.paymentTask.rechargeWay = "WX_PAY";
    },
    rechargeWayOFFLINE_REMIT() {
      this.paymentTask.rechargeWay = "OFFLINE_REMIT";
    },
    toPayMoney() {
      console.log("充值");
      this.clean();
      this.rechargeDialog = true;
    },
    async fnUploadremittanceImgs(option) {
      this.tableLoading = true;
      getAliyunPublicToken().then((res) => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken,
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        client
          .multipartUpload(storeAs, option.file, {})
          .then((results) => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList1 = files;
            let array = results.res.requestUrls[0].split("?");
            this.remittanceImgs.push(array[0]);
            this.tableLoading = false;
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    closeQRCodeDialog() {
      this.QRCodeDialog = false;
      this.handleList();
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      (params.page = this.page.currentPage), (params.size = pageSize);
      viDistributionSheetList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      console.log(this.page);
      viDistributionSheetList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.createTimeStart = params.startDate_endDate[0];
        params.createTimeEnd = params.startDate_endDate[1];
      } else {
        params.createTimeStart = "";
        params.createTimeEnd = "";
      }
      if (
        null != params.receiveTimeStart_receiveTimeEnd &&
        undefined != params.receiveTimeStart_receiveTimeEnd &&
        "" != params.receiveTimeStart_receiveTimeEnd
      ) {
        params.receiveTimeStart = params.receiveTimeStart_receiveTimeEnd[0];
        params.receiveTimeEnd = params.receiveTimeStart_receiveTimeEnd[1];
      } else {
        params.receiveTimeStart = "";
        params.receiveTimeEnd = "";
      }
      this.downloadData = params;
      viDistributionSheetList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size,
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.page.currentPage;
      params.size = page.page.pageSize;
      viDistributionSheetList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize,
        };
        this.tableLoading = false;
      });
    },

    handleDetail(row, index) {},
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {},
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize,
      };
      viDistributionSheetList(parmas).then((res) => {
        let data = JSON.parse(res.data);
        // console.log("集合："+JSON.stringify( data.rows))
        let params = this.$refs.crud.searchForm;
        
        console.log(params,111);
        console.log(data,5555);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {},

    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {},
    /**
     * 确认供货单
     * @param id
     */
    handleReceipt(row) {},
    /**
     * 确认配送
     * @param id
     */
    confirmDelivery(row) {},
    // immediatePayment(id) {
    //   payDistributionFee(id).then(res => {
    //     // let data = JSON.parse(res.data);
    //     this.config.value = res.data.codeUrl;
    //     this.QRCodeDialog = true;
    //   });
    // },
    immediatePayment(id) {
      payDistributionFee(id).then((response) => {
        this.tableLoading = false;
        if (response.code == "200") {
          let data = response.data;
          let count = 0;
          wxNativePayQuery(data.outTradeNo).then((res) => {
            if (res.code == "200") {
              if (res.data == "SUCCESS") {
                let _this = this;
                setTimeout(function () {
                  _this.QRCodeDialog = false;
                  _this.$message({
                    showClose: true,
                    message: "充值成功",
                    type: "success",
                  });
                  _this.handleList();
                  _this.payMoneyDialog = false;
                  _this.rechargeDialog = false;
                  _this.dialogBalancePay = false;
                }, 1000);
              } else {
                count++;
                if (count < 3) {
                  wxNativePayQuery(data.outTradeNo).then((res) => {
                    if (res.code == "200") {
                      if (res.data == "SUCCESS") {
                        let _this = this;
                        setTimeout(function () {
                          _this.QRCodeDialog = false;
                          _this.$message({
                            showClose: true,
                            message: "充值成功",
                            type: "success",
                          });
                          _this.handleList();
                          _this.payMoneyDialog = false;
                          _this.rechargeDialog = false;
                          _this.dialogBalancePay = false;
                        }, 1000);
                      } else {
                        this.QRCodeDialog = false;
                        this.rechargeDialog = false;
                        this.dialogBalancePay = false;
                        this.$message({
                          showClose: true,
                          message: "支付超时",
                          type: "error",
                        });
                      }
                    } else {
                      this.QRCodeDialog = false;
                      this.rechargeDialog = false;
                      this.dialogBalancePay = false;
                      this.$message({
                        showClose: true,
                        message: "支付超时",
                        type: "error",
                      });
                    }
                  });
                }
              }
              //this.handleList();
            } else {
              this.QRCodeDialog = false;
              this.$message({
                showClose: true,
                message: "支付失败",
                type: "error",
              });
              this.handleList();
            }
          });
          let start = new Date().getTime();
          while (true) if (new Date().getTime() - start > 1) break;
          this.config.value = "";
          this.config.value = data.codeUrl;
          this.QRCodeDialog = true;
        } else {
          this.$message({
            showClose: true,
            message: "支付失败",
            type: "error",
          });
          //???下面的感觉没用
          // this.$refs.crud.rowAdd();
          return;
        }
        // let data = JSON.parse(res.data);
      });
    },
    downloadExcel() {
      let params = this.downloadData;
      viDistributionSheetListDownloadExcel(params).then((res) => {
        if (res.code == "200") {
          window.open(res.data);
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
      });
    },
    doPrint() {
      this.isPrint = true;
      this.companyName = getCompany();
      this.$nextTick(() => {
        var printBox = document.getElementById("printBox");
        //拿到打印的区域的html内容
        var newContent = printBox.innerHTML;
        //将旧的页面储存起来，当打印完成后返给给页面。
        var oldContent = document.body.innerHTML;
        //赋值给body
        document.body.innerHTML = newContent;
        //执行window.print打印功能
        window.print();
        // 重新加载页面，以刷新数据。以防打印完之后，页面不能操作的问题
        document.body.innerHTML = oldContent;
        window.location.reload(false);
        return false;
      });
    },
  },
};
</script>
    <style scoped lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.typeButton {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.typeButton {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}
.stockwrap {
  background: #fff;
  margin: 1px 10px;
  padding-bottom: 100px !important;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.stockMain {
  // border: 1px solid #606266;
  display: flex;
  width: 100%;
  flex-flow: column wrap;
  justify-content: center;
  align-items: flex-start;
  margin: 1px 20px;
  font-size: 14px;
  color: #333;
  .content {
    border: none;
    ul {
      .titleLi {
        display: flex;
        justify-content: flex-start;
      }
      .titleLi .d {
        width: 300px;
        span {
          margin-right: 10px;
        }
      }
    }
  }
  .title {
    position: relative;
    left: 50%;
    border: none;
    font-weight: Medium;
    font-size: 22px;
    margin-bottom: 30px;
    color: #333;
    margin-left: -37px;
  }
  .btn {
    position: absolute;
    bottom: 20px;
    left: 0;
    border: none;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    button {
      margin: 0 20px;
    }
  }
}
.avue-crud {
  margin-right: 0;
  margin: 0;
}
.print {
  display: none;
}
</style>

<style lang="scss">
@media print {
  #printTime {
    width: 100%;
    position: absolute;
    bottom: 0;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
  }
  #printBox {
    position: relative;
    left: 0;
  }
  .el-table td,
  .el-table th.is-leaf {
    border-bottom: 1px solid #333;
  }
  .el-table--border td,
  .el-table--border th {
    border-right: 1px solid #333;
  }
  .el-table th {
    // border-top: 1px solid #333;
  }
  .el-table--border,
  .el-table--group {
    border: 1px solid #333;
  }
  .el-table--enable-row-transition {
    border: 1px solid #333;
  }

  #printTitle {
    position: relative;
    border: none;
    left: 50%;
    font-weight: Medium;
    font-size: 22px;
    margin-bottom: 30px;
    color: #333;
    margin-left: -37px;
  }
  #noprint {
    display: none;
  }
  .avue-crud {
    margin-right: 0;
    margin: 0;
    width: 900px;
  }
  #content {
    color: #333;
    border: none;
    margin-left: 6%;
    ul {
      .titleLi {
        display: flex;
        justify-content: flex-start;
      }
      .titleLi span {
        margin-left: 10px;
        color: #333;
      }
      .titleLi .d {
        width: 345px;
      }
    }
  }
}
.print {
  display: block;
}
</style>